import digitalData from 'digital-data';
import { getState } from '../analytics-state';
import {
  NOT_APPLICABLE, PIP, STASH, ATC, PRODUCT_POD
} from '../constants';

export const irg = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('@@IRG/CLICK', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@IRG/CLICK is deprecated.', 'background: red; color: black', payload);
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('product-pod-irg.add-to-cart', ({ output }) => {

    const {
      sku,
      displayPosition
    } = output || {};

    const { pageItemId = '' } = getState() || {};

    const ddoEvent = {
      eventInfo: {
        eventName: 'cart addition info'
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        component: PRODUCT_POD,
        item: [
          {
            productInfo: {
              sku
            },
            recommendation: {
              displayPosition,
              recommendationType: 'irg',
              pageType: PIP,
              anchorProductSku: pageItemId,
              strategy: 'irgcollection',
              recommendationVersion: NOT_APPLICABLE,
              featureVersion: NOT_APPLICABLE,
              interval: NOT_APPLICABLE
            }
          }
        ],
        pageType: PIP,
        section: 'irg',
        sharedSection: NOT_APPLICABLE,
        target: ATC
      }
    };

    (digitalData?.event || []).push(ddoEvent);
  });
};
